var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var BetBtnMlQa = /** @class */ (function (_super) {
    __extends(BetBtnMlQa, _super);
    function BetBtnMlQa(props) {
        var _this = _super.call(this, props) || this;
        _this.textDataUat = _this.props.dataUat ? _this.props.dataUat.text : "bet-title-team-name";
        _this.oddDataUat = _this.props.dataUat ? _this.props.dataUat.odds : "bet-odds-value";
        return _this;
    }
    BetBtnMlQa.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "bet_btn-information bet_btn-information--text", "data-uat": this.textDataUat }, this.props.text),
            React.createElement("span", { className: "bet_btn-information bet_btn-information--odd", "data-uat": this.oddDataUat }, this.props.odd)));
    };
    return BetBtnMlQa;
}(React.PureComponent));
export { BetBtnMlQa };
//# sourceMappingURL=BetBtnMlQa.js.map